import classNames from 'classnames';
import { forwardRef } from 'react';
const optionCss = "o1clr07j";
export const Option = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionCss, props.className)} />;
});

require("./option.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./option.js");